import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './NotFound.css';

const cx = classnames.bind(styles);

function NotFound({ className }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <p className={styles.title}>
                This page does not exist
            </p>
            <p className={styles.label}>
                We're sorry about that
            </p>
        </div>
    );
}

NotFound.defaultProps = {
    className: ''
};

NotFound.propTypes = {
    className: PropTypes.string
};

export {
    NotFound
};
